import { handleActions } from 'redux-actions';

interface Fragment {
    id: string;
    slide: number;
    animations: any[];
}

interface State {
    fragments: { [slide: number]: { [id: string]: Fragment } };
}

const initialState: State = {
    fragments: {},
};

const reducer = handleActions<State, any>(
    {
        ADD_FRAGMENT: (state, action) => {
            const { id, slide } = action.payload;
            const s = { ...state };
            s.fragments[slide] = s.fragments[slide] || {};
            s.fragments[slide][id] = action.payload;
            return s;
        },
        UPDATE_FRAGMENT: (state, action) => {
            const { fragment } = action.payload;
            const s = { ...state };
            s.fragments[fragment.slide][fragment.id].animations = action.payload.animations;
            return s;
        },
    },
    initialState,
);

export default reducer;
